import { DEFAULT_SIZE_NEWS } from '../commons/constants';
import { GET_PROJECT_API, GET_NEWS_API } from '../commons/constants/apis';
import { ResponseTypes, ResponsePagingTypes } from '../types/response/common';
import { NewsResponseTypes } from '../types/response/news';
import axios from './axios';

export const getNewsByProjectCode = async (
  projectCode: string,
  language: string,
  page?: number
): Promise<ResponsePagingTypes<NewsResponseTypes[]>> => {
  const { data }: ResponseTypes<ResponsePagingTypes<NewsResponseTypes[]>> = await axios.get(
    `${GET_PROJECT_API}/${projectCode}/newses`,
    {
      headers: { language },
      params: { page, size: DEFAULT_SIZE_NEWS },
    }
  );
  return data;
};

export const getNewsByCode = async (
  newsCode: string,
  language: string
): Promise<NewsResponseTypes> => {
  const { data }: ResponseTypes<NewsResponseTypes> = await axios.get(
    `${GET_NEWS_API}/${newsCode}`,
    {
      headers: { language },
    }
  );
  return data;
};
